import React from "react";
import { useNavigate } from "react-router-dom";
import { TextInput, Button } from "@twioku/common_components";
import { Path } from "../routes/PagePath";
import { Controller } from "react-hook-form";
import { useNewAnswererInfo } from "../features/newAnswererInfo/hooks/useNewAnswererInfo";

export const ReceiverNicknamePage: React.FC = () => {
    const navigate = useNavigate();
    const { form } = useNewAnswererInfo();
    const {
        control,
        watch,
        formState: { errors },
    } = form;

    const receiverNickname = watch("receiverNickname");

    // このページではreceiverNicknameのバリデーションだけをチェック
    const isReceiverNicknameValid = !errors.receiverNickname;

    const onSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (isReceiverNicknameValid) {
            navigate(Path.answererRequiredInfo);
        }
    };

    return (
        <>
            <div className="mx-6">
                <form onSubmit={onSubmit}>
                    <h1 className="mb-8 mt-5 text-center text-xl font-bold">
                        まずはあなたの
                        <br />
                        お名前(ニックネーム)を教えてください。
                    </h1>
                    <div>
                        <Controller
                            name="receiverNickname"
                            control={control}
                            render={({ field, fieldState }) => (
                                <TextInput
                                    {...field}
                                    type="text"
                                    placeholder="例) たかあき"
                                    errorMessage={
                                        fieldState.isDirty ||
                                        fieldState.isTouched
                                            ? fieldState.error?.message
                                            : undefined
                                    }
                                    className="w-full"
                                />
                            )}
                        />
                    </div>
                    <div className="mb-5 mt-3 text-sm text-gray-500">
                        <p className="mb-3">
                            ※お相手の方への通知メールなどに使用します。
                            <br />
                            あなたのことについて聞かれていることがわかるような呼称を入力してください。
                        </p>

                        <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
                            <p className="mb-2 text-xs font-medium text-gray-400">
                                メール文例
                            </p>
                            <div className="text-xs leading-relaxed text-gray-600">
                                <p className="mb-2">
                                    [親の名前]さん こんにちは！
                                </p>
                                <p>
                                    <span className="font-bold underline">
                                        {receiverNickname
                                            ? `${receiverNickname}さん`
                                            : "[子の名前]さん"}
                                    </span>
                                    の子供の頃について教えてください。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="fixed bottom-0 left-1/2 w-11/12 -translate-x-1/2">
                        <Button
                            type="submit"
                            className="mb-8 mt-2 h-12 w-full"
                            disabled={!isReceiverNicknameValid}
                        >
                            次へ
                        </Button>
                    </div>
                </form>
            </div>
        </>
    );
};
